import React from 'react';
import BaseMaskedInput from '../../BaseMaskedInput';

const SocialSecurityNumberInput = (props) => {
  return (
    <BaseMaskedInput
      {...props}
      placeholder={''}
      mask={[
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
    />
  );
};

export default SocialSecurityNumberInput;
